import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentMovementsPanel = ({ transactions }) => {
  const getTransactionIcon = (type) => {
    switch (type) {
      case 'stock_in':
        return { name: 'ArrowDownCircle', color: 'var(--color-success)' };
      case 'stock_out':
        return { name: 'ArrowUpCircle', color: 'var(--color-error)' };
      case 'transfer':
        return { name: 'ArrowRightCircle', color: 'var(--color-info)' };
      case 'adjustment':
        return { name: 'Edit', color: 'var(--color-warning)' };
      case 'reorder':
        return { name: 'ShoppingCart', color: 'var(--color-primary)' };
      default:
        return { name: 'Package', color: 'var(--color-muted-foreground)' };
    }
  };

  const getTransactionLabel = (type) => {
    switch (type) {
      case 'stock_in':
        return 'Stock In';
      case 'stock_out':
        return 'Stock Out';
      case 'transfer':
        return 'Transfer';
      case 'adjustment':
        return 'Adjustment';
      case 'reorder':
        return 'Reorder';
      default:
        return type;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Activity" size={20} color="var(--color-primary)" />
        </div>
        <h3 className="text-lg font-heading font-semibold text-foreground">
          Recent Movements
        </h3>
      </div>

      <div className="space-y-3 max-h-96 overflow-y-auto">
        {transactions && transactions?.length > 0 ? (
          transactions?.map((transaction) => {
            const icon = getTransactionIcon(transaction?.transaction_type);
            return (
              <div
                key={transaction?.id}
                className="p-3 bg-muted/30 rounded-lg border border-border hover:bg-muted/50 transition-colors"
              >
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${icon?.color}20` }}>
                    <Icon name={icon?.name} size={16} color={icon?.color} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between mb-1">
                      <p className="font-medium text-foreground text-sm truncate">
                        {transaction?.products?.name}
                      </p>
                      <span className="text-sm font-semibold text-foreground ml-2">
                        {transaction?.transaction_type === 'stock_out' ? '-' : '+'}{transaction?.quantity}
                      </span>
                    </div>
                    <p className="text-xs text-muted-foreground font-mono mb-1">
                      {transaction?.products?.sku}
                    </p>
                    <div className="flex items-center gap-2">
                      <span className="text-xs px-2 py-0.5 rounded-full bg-muted text-muted-foreground">
                        {getTransactionLabel(transaction?.transaction_type)}
                      </span>
                      {transaction?.location && (
                        <span className="text-xs text-muted-foreground flex items-center gap-1">
                          <Icon name="MapPin" size={10} />
                          {transaction?.location}
                        </span>
                      )}
                    </div>
                    {transaction?.notes && (
                      <p className="text-xs text-muted-foreground mt-1 line-clamp-1">
                        {transaction?.notes}
                      </p>
                    )}
                    <p className="text-xs text-muted-foreground mt-1">
                      {formatDate(transaction?.created_at)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center py-8">
            <Icon name="Activity" size={32} className="mx-auto mb-2 text-muted-foreground" />
            <p className="text-sm text-muted-foreground">No recent movements</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentMovementsPanel;